import httpClient from "@/core/axios";

import emails from "@/store/profile/emails";
import phones from "@/store/profile/phones";
import consents from "@/store/profile/consents";
import invoices from "@/store/profile/invoices";
import reservations from "@/store/profile/reservations";

export default {
    namespaced: true,
    state: {
        profile: {}
    },
    getters: {
        profile(state) {
            return state.profile;
        },
        profile_info(state) {
            return {
                title: state.profile.title,
                first_name: state.profile.first_name,
                last_name: state.profile.last_name
            };
        }
    },
    actions: {
        async fetch(context) {
            return httpClient
                .get(`/api/guest/app/:app_uuid/user/profile`)
                .then(data => context.commit("SET_PROFILE", data));
        },
        async updateProfileInfo(context) {
            return httpClient
                .post(`/api/guest/app/:app_uuid/user/profile`, {
                    title: context.state.profile.title,
                    first_name: context.state.profile.first_name,
                    last_name: context.state.profile.last_name
                })
                .then(data => context.commit("SET_PROFILE", data));
        }
    },
    mutations: {
        SET_PROFILE(state, data) {
            state.profile = data;
        },
        SET_PROFILE_INFO(state, { first_name, last_name, title }) {
            state.profile.title = title;
            state.profile.first_name = first_name;
            state.profile.last_name = last_name;
        }
    },
    modules: {
        emails,
        phones,
        consents,
        invoices,
        reservations
    }
};
